/* eslint-disable @typescript-eslint/no-unnecessary-condition */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { useEffect } from 'react'
import { getCurrentCategory } from '@velasca/utils/get-current-category'
import { useCategoryStore } from './useCategoryStore'
import { useSingleCategory } from './useSingleCategory'

export const useCategoryManager = () => {
  const setCurrentCategory = useCategoryStore(
    (state: { setCurrentCategoryName: (name: string) => void }) =>
      state.setCurrentCategoryName,
  )

  useEffect(() => {
    const category = getCurrentCategory(window.location.pathname) ?? ''

    setCurrentCategory(category)
  }, [setCurrentCategory])

  const setCurrentCategoryHasShoes = useCategoryStore(
    (state) => state.setCurrentCategoryHasShoes,
  )

  const setCurrentCategoryIsMainCollection = useCategoryStore(
    (state) => state.setCurrentCategoryIsMainCollection,
  )

  const setCurrentCategoryIsSubCollection = useCategoryStore(
    (state) => state.setCurrentCategoryIsSubCollection,
  )

  const currentCategory = useCategoryStore((state) => state.currentCategory)

  const { data: dataSingleCategory } = useSingleCategory({
    variables: {
      handle: currentCategory.name,
    },
  })

  useEffect(() => {
    if (dataSingleCategory?.collection.hasShoes !== undefined) {
      setCurrentCategoryHasShoes(
        dataSingleCategory.collection.hasShoes?.value === 'true' ||
          dataSingleCategory.collection.hasShoes?.value === true,
      )
    }
    setCurrentCategoryIsMainCollection(
      dataSingleCategory?.collection?.isMainCollection?.value === 'true' ||
        dataSingleCategory?.collection.isMainCollection?.value === true,
    )
    setCurrentCategoryIsSubCollection(
      dataSingleCategory?.collection.isSubCollection?.value === 'true' ||
        dataSingleCategory?.collection.isSubCollection?.value === true,
    )
  }, [
    dataSingleCategory,
    setCurrentCategoryHasShoes,
    setCurrentCategoryIsMainCollection,
    setCurrentCategoryIsSubCollection,
  ])

  return {
    currentCategory,
    dataSingleCategory,
  }
}
